const CfddCustomerChannel = () =>
  import('@/views/main/helper/cfddCustomerChannel/CfddCustomerChannel.vue')
export default {
  path: '/main/helper/cfddCustomerChannel',
  name: 'CfddCustomerChannel',
  component: CfddCustomerChannel,
  children: []
}
